import { WeightUnit } from "@/Common/Utilities/Units/Units";
import { WeightUnitConverter } from "@/Common/Utilities/Units/WeightUnitConverter";
import { ObstetricalExamResultState } from "@/Patient/Models/ObstetricalFile/ObstetricalExamResultState";

class OntarioObstetricalPostnatalPhysicalExam {
    public EmrTemplateId: string; // Weight today and blood pressure.
    public PreDeliveryWeight: number;
    public AffectExam: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public AbdomenExam: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public ThyroidExam: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public PerineumExam: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public BreastsExam: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public PelvicExam: ObstetricalExamResultState = ObstetricalExamResultState.NotDone;
    public Comments: string;
    public WeightTodayUnit: WeightUnit;
    public PreDeliveryWeightUnit: WeightUnit;

    public get ConvertedPreDeliveryWeight(): number {
        return WeightUnitConverter.convert(WeightUnit.Kilogram, this.PreDeliveryWeightUnit, this.PreDeliveryWeight, 2);
    }

    public set ConvertedPreDeliveryWeight(value: number) {
        this.PreDeliveryWeight = WeightUnitConverter.convert(this.PreDeliveryWeightUnit, WeightUnit.Kilogram, value);
    }

    public constructor(fields?: Partial<OntarioObstetricalPostnatalPhysicalExam>) {
        this.WeightTodayUnit = this.defaultWeightUnit();
        this.PreDeliveryWeightUnit = this.defaultWeightUnit();
        Object.assign(this, fields);
    }

    public defaultWeightUnit(): WeightUnit {
        return sessionStore.useMetricSystemAsDefault ? WeightUnit.Kilogram : WeightUnit.Pound;
    }
}

export { OntarioObstetricalPostnatalPhysicalExam };
